import * as React from "react";
const SvgFiRrBottle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.856 8.065 15 7.323V2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2v5.323l-1.856.742A4.98 4.98 0 0 0 4 12.708V19a5.006 5.006 0 0 0 5 5h6a5.006 5.006 0 0 0 5-5v-6.292a4.98 4.98 0 0 0-3.144-4.643M18 19a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-6.292a2.98 2.98 0 0 1 1.886-2.785l2.486-.994A1 1 0 0 0 11 8V2h2v6a1 1 0 0 0 .629.929l2.485.994A2.98 2.98 0 0 1 18 12.708zm-3-6H9a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4h-4v-2h4z"
    />
  </svg>
);
export default SvgFiRrBottle;
